__turbopack_context__.v({
  "asset": "Hero1-module__FVvI-q__asset",
  "mainAsset": "Hero1-module__FVvI-q__mainAsset",
  "root": "Hero1-module__FVvI-q__root",
  "secondaryAsset": "Hero1-module__FVvI-q__secondaryAsset",
  "secondaryAssetWrap": "Hero1-module__FVvI-q__secondaryAssetWrap",
  "sentinel": "Hero1-module__FVvI-q__sentinel",
  "text": "Hero1-module__FVvI-q__text",
  "title": "Hero1-module__FVvI-q__title",
});
